import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { topics } from "@/mocks/home";

export default function TopicsSection() {
  return (
    <section className="mt-16 bg-background-100 py-14 md:mt-20 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-8">
        <SectionHeading
          eyebrow="热门影视专题"
          title="编辑精选 · 主题合集"
          desc="由 91蜜桃编辑团队策划整理的影视专题，帮你快速找到值得一看的好作品。"
          moreLink="/category/movie"
          moreLabel="全部合集"
        />

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5">
          {topics.map((topic, index) => (
            <Link
              key={topic.id}
              to={`/search?q=${encodeURIComponent(topic.query)}`}
              className="group animate-fade-up overflow-hidden rounded-lg border border-background-200 bg-background-50 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md"
              style={{ animationDelay: `${index * 80}ms` }}
            >
              <div className="relative h-40 w-full overflow-hidden md:h-44">
                <img
                  src={topic.cover}
                  alt={`${topic.title} 合集封面`}
                  title={`${topic.title} - 91蜜桃影视专题`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/70 to-transparent" />
                <span className="absolute bottom-3 left-3 rounded-full bg-accent-500 px-2.5 py-0.5 text-xs font-bold text-secondary-950">
                  {topic.count}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {topic.title}
                </h3>
                <p className="mt-1.5 line-clamp-2 text-sm text-foreground-500">
                  {topic.desc}
                </p>
                <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                  进入合集
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}